import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ViewMore}
 */

const ViewMore = ({ children }) => {
    return (
        <div className='module-view-more'>

        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ViewMore;
